import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy, Flame } from "lucide-react";

const Streak = ({ n, testid }) => (n >= 2 ? (
  <span className="inline-flex items-center gap-0.5 rounded-full bg-orange-100 px-1.5 py-0.5 text-[10px] font-bold text-orange-700" title={`Top 3 for ${n} weeks in a row`} data-testid={testid}>
    <Flame className="h-3 w-3" />{n}-wk streak
  </span>
) : null);

export function PartnerLeaderboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/my/partner-leaderboard").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return null;
  const since = new Date(d.week_start).toLocaleDateString(undefined, { month: "short", day: "numeric", timeZone: "UTC" });
  return (
    <div className="rounded-xl border border-border bg-white p-4" data-testid="partner-leaderboard">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-2">
        <span className="font-display font-bold text-sam-navy inline-flex items-center gap-2"><Trophy className="h-4 w-4 text-sam-amber" />This week's leaderboard</span>
        <span className="text-[11px] text-sam-slate">Since Mon {since} · link clicks + prospects loaded</span>
      </div>
      {d.top.length === 0 ? <p className="text-xs text-sam-slate" data-testid="partner-leaderboard-empty">No activity yet this week. Share your links to take the top spot.</p> : (
        <ol className="space-y-1">
          {d.top.map((r) => (
            <li key={r.rank} className={`flex items-center gap-3 rounded-lg px-2 py-1.5 text-sm ${r.me ? "bg-sam-crimson/10 font-semibold" : ""}`} data-testid={`partner-leaderboard-row-${r.rank}`}>
              <span className="w-6 text-center font-display font-black text-sam-navy">{r.rank}</span>
              <span className="flex-1 text-sam-navy">{r.me ? "You" : r.name} <Streak n={r.streak} testid={`partner-streak-${r.rank}`} /></span>
              <span className="text-xs text-sam-slate">{r.clicks} clicks · {r.prospects} prospects</span>
            </li>
          ))}
        </ol>
      )}
      {d.me.streak >= 2 && <p className="mt-2 text-xs font-semibold text-orange-700" data-testid="partner-my-streak">You've finished top 3 for {d.me.streak} weeks in a row. Keep the streak alive!</p>}
      {d.me.rank > 10 && <p className="mt-2 text-xs font-semibold text-sam-navy" data-testid="partner-leaderboard-me">You're #{d.me.rank} of {d.partners} · {d.me.clicks} clicks · {d.me.prospects} prospects</p>}
      {!d.me.rank && d.top.length > 0 && <p className="mt-2 text-xs text-sam-slate" data-testid="partner-leaderboard-me">You're not on the board yet this week.</p>}
    </div>
  );
}
